module.exports = __webpack_public_path__ + "static/media/brand.c62dcd16.png";